import { createAsyncThunk } from '@reduxjs/toolkit';
import { ROLLBACK_API_URL } from '@custom/constant';
import { RollbackRequestArgs } from '@custom/Utils/constants/interfaces';

// Async thunk for rollback request
export const rollbackRequest = createAsyncThunk(
  'report/rollback',
  async ({ _id, rollbackReason, rollbackNotes, rollbackStatus }: RollbackRequestArgs, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(ROLLBACK_API_URL, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          _id: _id,
          rollbackReason: rollbackReason,
          rollbackNotes: rollbackNotes,
          rollbackStatus: rollbackStatus,
        }),
      });

      if (!response.ok) {
        throw new Error('Failed to rollback report');
      }

      return await response.json(); // Return the response data
    } catch (error) {
      return rejectWithValue(error.message); // Handle error
    }
  }
);

export default rollbackRequest;
